import React from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import PhysicianProfileSidebar from "../Components/PhysicianProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { userpatient } from "../Constant/Index";

const PhysicianPrescription = () => {
	return (
		<>
			<Header />
			<PageHeader pagename="Physician Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<PhysicianProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div class="edit-btn back">
										<Link to="/">
											<div class="nav-anchor">
												<i class="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<h5 class="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
										Prescription
									</h5>
								</div>
								<div className="row">
									<div class="col-lg-12">
										<div class="content-qty extra-bg-14 radius-20 p-4 dark-color ">
											<div className="d-flex gap-3 align-items-center">
												<img src={userpatient} className="img-fluid" alt="" />
												<div>
													<h4 class="main-heading-font level-6 ">John Doe</h4>
													<h5 class="primary-medium-font level-8 extra-color-15">
														Patient
													</h5>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-lg-12">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color">
											<h4 class="main-heading-font level-6 ">Prescription</h4>
											<p className="extra-color-16">
												Sed ut perspiciatis unde omnis iste natus error sit
												voluptatem accusantium doloremque laudantium, totam rem
												aperiam, eaque ipsa quae ab illo inventore veritatis et
												quasi architecto beatae vitae dicta sunt explicabo. Nemo
												enim ipsam voluptatem quia voluptas sit aspernatur aut
												odit aut fugit, sed quia consequuntur magni dolores eos
												qui ratione voluptatem sequi nesciunt.
											</p>
											<div className="d-flex align-items-center gap-3 mt-2">
												<h4 className="extra-color-16 level-7">
													laudantium otam{" "}
												</h4>
												<h4 className="extra-color-16 level-7">- X2</h4>
											</div>
											<div className="d-flex align-items-center gap-3 mt-2">
												<h4 className="extra-color-16 level-7">rem aperiam </h4>
												<h4 className="extra-color-16 level-7">- X3</h4>
											</div>
											<div className="d-flex align-items-center gap-3 mt-2">
												<h4 className="extra-color-16 level-7">
													veritatis et quasi{" "}
												</h4>
												<h4 className="extra-color-16 level-7">- X4</h4>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default PhysicianPrescription;
